import { module } from 'angular'
import { HotkeysService } from './hotkeys.service'
import { HotkeyDirective } from './hotkey.directive'

module('webregister.components')
  .service('hotkeysService', HotkeysService)
  .directive('hotkey', HotkeyDirective)
